/**
 *  TODO: Возможно надо реорганизовать архитектуру модулей.
 */
export default {
  product: {
    product: {
      attr: 'data-product-id',
      css: '[data-product-id]',
      data: 'product-id'
    },
    item: {
      attr: 'data-item-id',
      css: '[data-item-id]',
      data: 'item-id',
    },
  },
  quantity: {
    container: {
      attr_init: 'data-quantity-change-init',
      attr_init_css: '[data-quantity-change-init]',
      attr: 'data-quantity',
      css: '[data-quantity]',
    },
    button: {
      attr: 'data-quantity-change',
      css: '[data-quantity-change]',
      data: 'quantity-change',
    },
    input: {
      attr: '',
      css: '[name*="quantity"]',
    }
  },
  options: {
    'native': {
      attr: 'data-product-variants',
      css: '[data-product-variants]',
      data: 'product-variants',
    },
    rendered: {
      attr: 'data-option-selector',
      css: '[data-option-selector]',
      data: 'option-selector',
      class_name: 'option-selector',
    },
    option: {
      attr: 'data-option-bind',
      css: '[data-option-bind]',
      data: 'option-bind',
    }
  }
};
